<template>
  <div class="tableContainer">
    <!-- <div class="filterButtonPosition" style="right: 64px">
      <f7-button
        fill
        class="whiteFontColor button-filter"
        panel-toggle="right"
      >
        <span class="ic-filter"></span> {{ $t('filter') }}
      </f7-button>
    </div> -->
    <DxDataGrid
      ref="dataGrid"
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataTextDetail')"
      class="custom-grid custom-grid-detail-food"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
      @content-ready="init"
    >
      <DxScrolling mode="standard" />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="lmr_semaphore"
        caption=""
        :width="35"
        :allow-sorting="false"
        cell-template="cellTemplateDots"
        alignment="center"
        :fixed="true"
        fixed-position="left"
      />

      <template #cellTemplateDots="{ data }">
        <div class="dots-parent-container">
          <img
            width="20"
            height="20"
            :src="getDotColorImage(data.value)"
          />
        </div>
      </template>

      <!-- <DxColumn
        data-field="parameter_group"
        :caption="$t('group')"
        alignment="left"
        :allow-header-filtering="false"
      /> -->

      <DxColumn
        data-field="parameter"
        :caption="$t('foodSamples.parameter')"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="result_value"
        :caption="$t('foodSamples.result')"
        :calculate-cell-value="calculateResultValue"
        :customize-text="customizeResultText"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="unit_value"
        :caption="$t('foodSamples.unit')"
        :calculate-cell-value="calculateUnitValue"
        :allow-header-filtering="false"
      />

      <DxColumn
        :caption="$t('foodSamples.range')"
        :allow-header-filtering="false"
        alignment="left"
        :calculate-cell-value="calculateRange"
        width="150"
      />

      <DxExport :enabled="true" />
      <!-- <template #cellTemplateHeaderDots="{ data }">
        <div>
          <PopUp position="top">
            <div style="padding: 10px">
              <div class="pop-up-info">
                <img
                  :src="getDotColorImage('grey')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('foodSamples.detailRP.greyDotDescription') }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotColorImage('green')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('foodSamples.detailRP.greenDotDescription') }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotColorImage('red')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('foodSamples.detailRP.redDotDescription') }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotColorImage('orange')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('foodSamples.detailRP.orangeDotDescription')
                  }}
                </div>
              </div>
            </div>
          </PopUp>
        </div>
      </template> -->
    </DxDataGrid>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
// import PopUp from '@/components/UtilityComponents/popUpInfo/popUp.vue';

export default {
  name: 'FoodSamplesDetailTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
    DxSearchPanel,
    // PopUp,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    isAppliedFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gridInstance: null,
    };
  },
  computed: {
    ...mapState('foodDetailsFilter', ['selectedLMRs']),
    ...mapState('samples', ['reportSampleCode']),
  },
  watch: {
    selectedLMRs: {
      handler() {
        this.updateLmrColumns();
      },
      deep: true,
    },
  },

  // beforeUpdate() {
  //   if (!this.gridInstance) return;

  //   const dataSource = this.gridInstance.getDataSource().items();

  //   if (this.isAppliedFilter) {
  //     if (this.selectedLMRs.length > 0) {
  //       dataSource.forEach((item) => {
  //         item.lmr.forEach((itemLMR, itemLMRIndex) => {
  //           this.selectedLMRs.forEach((selectedLMR) => {
  //             if (selectedLMR === itemLMR.CodPais) {
  //               if (
  //                 this.columnExists(
  //                   this.gridInstance.columnCount(),
  //                   `LMR ${selectedLMR}`
  //                 ) === -1
  //               ) {
  //                 this.gridInstance.addColumn({
  //                   caption: `LMR ${selectedLMR}`,
  //                   dataField: `lmr[${itemLMRIndex}].Valor`,
  //                   alignment: 'left',
  //                   allowHeaderFiltering: 'false',
  //                 });
  //               }
  //             }
  //           });
  //         });
  //       });

  //       this.deleteColumns();
  //     } else if (
  //       this.gridInstance
  //         .columnOption(this.gridInstance.columnCount() - 1)
  //         .caption.includes('LMR')
  //     ) {
  //       this.gridInstance.deleteColumn(
  //         this.gridInstance.columnCount() - 1
  //       );
  //     }
  //   } else {
  //     this.deleteColumns();

  //     for (let i = 0; i < this.gridInstance.columnCount(); i += 1) {
  //       if (
  //         this.gridInstance.columnOption(i).caption.includes('LMR')
  //       ) {
  //         this.gridInstance.deleteColumn(i);
  //       }
  //     }

  //     if (
  //       this.gridInstance
  //         .columnOption(this.gridInstance.columnCount() - 1)
  //         .caption.includes('LMR')
  //     ) {
  //       this.gridInstance.deleteColumn(
  //         this.gridInstance.columnCount() - 1
  //       );
  //     }
  //   }
  // },

  methods: {
    getDotColorImage(color) {
      return require(`../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    getGridInstance() {
      return this.$refs.dataGrid?.instance || null;
    },
    updateLmrColumns() {
      if (!this.gridInstance) return;

      const dataSource =
        this.gridInstance.getDataSource().items() || [];

      // 1. Si no hay LMR seleccionados: quitamos TODAS las columnas LMR
      if (!this.selectedLMRs || this.selectedLMRs.length === 0) {
        for (
          let i = this.gridInstance.columnCount() - 1;
          i >= 0;
          i -= 1
        ) {
          const column = this.gridInstance.columnOption(i);
          if (column.caption && column.caption.includes('LMR')) {
            this.gridInstance.deleteColumn(i);
          }
        }
        return;
      }

      dataSource.forEach((item) => {
        if (!item.lmr) return;

        item.lmr.forEach((itemLMR, itemLMRIndex) => {
          const code = itemLMR.CodPais;

          if (this.selectedLMRs.includes(code)) {
            const caption = `LMR ${code}`;

            if (
              this.columnExists(
                this.gridInstance.columnCount(),
                caption
              ) === -1
            ) {
              this.gridInstance.addColumn({
                caption,
                dataField: `lmr[${itemLMRIndex}].Valor`,
                alignment: 'left',
                allowHeaderFiltering: false,
              });
            }
          }
        });
      });

      this.deleteColumns();
    },

    columnExists(columnCount, name) {
      for (let i = 0; i < columnCount; i += 1) {
        if (this.gridInstance.columnOption(i).caption === name) {
          return i;
        }
      }
      return -1;
    },

    deleteColumns() {
      for (
        let i = this.gridInstance.columnCount() - 1;
        i >= 0;
        i -= 1
      ) {
        const columnName = this.gridInstance.columnOption(i).caption;

        if (columnName && columnName.includes('LMR')) {
          const formattedColumnName = columnName.split(' ')[1].trim();

          if (!this.selectedLMRs.includes(formattedColumnName)) {
            this.gridInstance.deleteColumn(i);
          }
        }
      }
    },
    init(e) {
      this.setSampleDetails(e.component.getDataSource().items());

      this.gridInstance = e.component;

      this.updateLmrColumns();
    },

    calculateRange(rowData) {
      return `${rowData.value.r_min} - ${rowData.value.r_max}`;
    },
    calculateResultValue(rowData) {
      return rowData?.value?.ResultadoPresentacion ?? '';
    },
    calculateUnitValue(rowData) {
      return rowData?.value?.unit ?? '';
    },
    customizeResultText(cellInfo) {
      return cellInfo.valueText?.includes('En Proceso')
        ? this.$t('inProcess')
        : cellInfo.valueText;
    },
    onExporting(e) {
      this.setIsExporting(true);
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        this.$t('foodSamples.exportExcelRpName')
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `besafer-${this.reportSampleCode}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'after';
        }
        if (item.name === 'exportButton') {
          item.location = 'after';
        }

        // if (item.name === 'groupPanel') {
        //   item.location = 'after';
        // }
      });

      toolbarItems.push({
        name: 'Filtros',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: '',
          icon: '././static/icons/ic_filter.svg',
          width: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    ...mapActions('foodSamples', [
      'setSampleDetails',
      'setIsExporting',
    ]),
  },
};
</script>

<style>
/* El <f7-button> se renderiza con la clase .button */
.button.whiteFontColor {
  display: inline-flex !important; /* sobrepone el inline-block del tema */
  align-items: center; /* centra icono y texto verticalmente */
  gap: 8px; /* separación icono–texto */
}

/* El contenedor del icono */
.button .icon-wrap {
  display: inline-flex;
  align-items: center;
  line-height: 0; /* elimina ajuste por línea base */
}

.button .icon-wrap svg {
  display: block;
  width: 20px; /* ajusta si quieres más/menos tamaño */
  height: 20px;
}

.custom-grid-detail-food .dx-searchbox .dx-texteditor-input {
  font-size: 14px !important;
  color: #333 !important;
  padding-left: 28px !important;
}

/* Ícono de la lupa */
.custom-grid-detail-food
  .dx-datagrid-search-panel
  .dx-searchbox
  .dx-icon.dx-icon-search {
  color: #00346a !important;
  left: 8px !important;
}

.custom-grid-detail-food .dx-toolbar-after {
  left: initial !important;
}
/* Quitar huecos laterales del header */
.custom-grid-detail-food .dx-datagrid-headers {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.custom-grid-detail-food .dx-datagrid-headers .dx-datagrid-content {
  padding: 0 !important;
}
.custom-grid-detail-food .dx-datagrid-headers .dx-datagrid-table {
  border-collapse: separate;
  border-spacing: 0 !important; /* sin gaps a los lados */
  width: 100%;
}

/* (opcional) aclarar el borde inferior de las cabeceras */
.custom-grid-detail-food .dx-datagrid-headers .dx-header-row > td {
  border-color: #e6e9ef !important;
}

/* Bordes redondeados en extremos de cada fila */
.custom-grid-detail-food
  .dx-datagrid-rowsview
  .dx-row.dx-data-row
  > td:first-child,
.custom-grid-detail-food
  .dx-datagrid-rowsview
  .dx-group-row
  > td:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.custom-grid-detail-food
  .dx-datagrid-rowsview
  .dx-row.dx-data-row
  > td:last-child,
.custom-grid-detail-food
  .dx-datagrid-rowsview
  .dx-group-row
  > td:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.custom-grid-detail-food .dx-searchbox {
  width: 200px !important;
}
/* Fila de grupo en verde */
.custom-grid-detail-food .dx-datagrid-rowsview .dx-group-row > td {
  background-color: #f2f8e2 !important;
}

.custom-grid-detail-food .dx-toolbar-after {
  display: grid;
  grid-template-columns: 106px 100px 47px 36px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-food .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-detail-food .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-food .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
  justify-self: start;
}

[class*='custom-grid-detail-'] .dx-datagrid-search-panel.dx-textbox {
  height: 40px !important;
  border: 1px solid #00346a !important;
  border-radius: 24px !important;
  background-color: #fff !important;
  box-sizing: border-box;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
}

/* Contenedor interno del buscador */
[class*='custom-grid-detail-']
  .dx-datagrid-search-panel
  .dx-texteditor-container {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
}

/* Ícono lupa */
[class*='custom-grid-detail-']
  .dx-datagrid-search-panel
  .dx-icon.dx-icon-search {
  color: #00346a !important;
  left: 10px !important;
  width: 16px !important;
  height: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Input de texto del buscador */
[class*='custom-grid-detail-']
  .dx-datagrid-search-panel
  .dx-texteditor-input {
  height: 38px !important;
  line-height: 38px !important;
  padding-left: 28px !important;
  color: #00346a !important;
  font-size: 14px !important;
}

/* Botones (filtro, exportar, etc.) */
[class*='custom-grid-detail-'] .dx-toolbar-after .dx-button {
  height: 40px !important;
  width: 40px !important;
  border: 1px solid #00346a !important;
  border-radius: 10px !important;
  background-color: #fff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box;
}

/* Contenido interno del botón (centra el ícono) */
[class*='custom-grid-detail-']
  .dx-toolbar-after
  .dx-button
  .dx-button-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Ícono dentro del botón */
[class*='custom-grid-detail-'] .dx-toolbar-after .dx-button .dx-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  top: 0 !important; /* si queda muy arriba, prueba con 1px */
  color: #00346a !important;
  font-size: 16px !important;
}

/* Alineación vertical de todo el toolbar */
[class*='custom-grid-detail-'] .dx-toolbar-after {
  align-items: center !important;
}
/* Input más grande */
.custom-grid-detail-food .dx-searchbox .dx-texteditor-input {
  padding-left: 36px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* Contenedor */
.custom-grid-detail-food .dx-searchbox {
  position: relative;
  height: 40px !important;
}

/* ICONO */
.custom-grid-detail-food .dx-searchbox::before {
  content: '';
  position: absolute;

  left: 7px;
  top: 45%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;

  background-image: url('@/static/icons/ic_search_blue.svg');
  background-repeat: no-repeat;
  background-size: 24px 24px;

  pointer-events: none;
}
</style>
